import React from 'react';

import first from 'lodash/fp/first';

import { Badge, Text } from '@lumapps/lumx/react';
import { UserReactions } from '@lumapps/reactions-core/api/types';
import { UserList, UserListProps } from '@lumapps/user-ui/components/UserList';

export interface ReactionUserListProps {
    users: UserReactions[];
    userListProps: UserListProps;
    showUserReaction: boolean;
}

export const ReactionUserList: React.FC<ReactionUserListProps> = ({ users, userListProps, showUserReaction }) => {
    const getAdditionalUserBlockProps: UserListProps['getAdditionalUserBlockProps'] = React.useCallback(
        ({ id }: { id: string }) => ({
            avatarProps: {
                badge: (
                    <Badge color="light">
                        <Text as="span" typography="overline" color="dark">
                            {first(users.find(({ user: { userId } }) => userId === id)?.reactions)}
                        </Text>
                    </Badge>
                ),
            },
        }),
        [users],
    );

    return (
        <UserList
            getAdditionalUserBlockProps={showUserReaction ? getAdditionalUserBlockProps : undefined}
            hasLoadMoreButton
            {...userListProps}
        />
    );
};
